// src/screens/LinkedInDraft.js

export function LinkedInDraftScreen(container, state, actions) {
  const d = state.diagnosis;
  if (!d) { actions.navigate('result'); return; }

  // El borrador puede venir en distintas rutas del JSON
  const draft =
    d.linkedin_draft?.es ||
    d.linkedin_draft_es  ||
    (typeof d.linkedin_draft === 'string' ? d.linkedin_draft : '') ||
    '';

  const charCount = draft.length;
  const overLimit = charCount > 1300;

  container.innerHTML = `
    <div class="screen">
      <div class="top-bar">
        <div class="logo">
          <div class="logo-sq"><i class="ti ti-building-factory-2" aria-hidden="true"></i></div>
          <div><div class="logo-name">CONCREPRO</div></div>
        </div>
      </div>
      <div class="screen-body">
        <button class="btn-back" id="btn-back">
          <i class="ti ti-arrow-left" aria-hidden="true"></i> Resultado
        </button>
        <h2 style="font-size:20px;font-weight:500;margin:0 0 4px">Borrador LinkedIn</h2>
        <p style="font-size:13px;color:var(--dim);margin:0 0 14px">
          Listo para copiar. Edita a tu gusto antes de publicar.
        </p>

        <div class="card">
          <!-- Author header -->
          <div style="display:flex;align-items:center;gap:10px;padding-bottom:12px;border-bottom:1px solid var(--border);margin-bottom:12px">
            <div class="li-avatar" aria-hidden="true">EC</div>
            <div>
              <div style="font-size:14px;font-weight:500">Arq. Eugenio Carrasco</div>
              <div style="font-size:11px;color:var(--muted)">
                Consultor Técnico Sr. · Sika México · VP ICRI México
              </div>
            </div>
          </div>

          <!-- Post text -->
          ${draft
            ? `<div style="font-size:13px;color:var(--dim);line-height:1.65;white-space:pre-wrap;word-break:break-word"
                    id="draft-text">${draft}</div>`
            : `<div style="font-size:13px;color:var(--muted);font-style:italic;text-align:center;padding:16px 0">
                 Borrador no incluido en este diagnóstico.<br>
                 Intenta regenerar el análisis.
               </div>`}

          <!-- Char count -->
          ${draft ? `
            <div class="mono" style="font-size:10px;color:${overLimit ? 'var(--sev-crit)' : 'var(--muted)'};text-align:right;margin-top:10px">
              ${charCount} / 1,300 caracteres${overLimit ? ' ⚠ supera el límite' : ''}
            </div>` : ''}
        </div>

        <!-- Copy button -->
        <button id="btn-copy" class="btn-primary" ${!draft ? 'disabled' : ''}>
          <i class="ti ti-copy" aria-hidden="true" id="copy-icon"></i>
          <span id="copy-label">Copiar texto completo</span>
        </button>

        <!-- Open LinkedIn -->
        ${draft ? `
          <a id="btn-linkedin-open"
             href="https://www.linkedin.com/feed/" target="_blank" rel="noopener"
             style="display:flex;align-items:center;justify-content:center;gap:7px;width:100%;padding:11px;background:transparent;border:1px solid var(--border2);border-radius:var(--r-md);color:var(--text);font-family:var(--f-body);font-size:13px;cursor:pointer;text-decoration:none;margin-top:8px;transition:border-color .15s">
            <i class="ti ti-brand-linkedin" aria-hidden="true"></i> Abrir LinkedIn
          </a>` : ''}

        <button class="btn-secondary" id="btn-back-2">
          <i class="ti ti-arrow-left" aria-hidden="true"></i> Volver al diagnóstico
        </button>
      </div>
    </div>`;

  // Back
  container.querySelector('#btn-back')?.addEventListener('click', () => actions.navigate('result'));
  container.querySelector('#btn-back-2')?.addEventListener('click', () => actions.navigate('result'));

  // Copy
  container.querySelector('#btn-copy')?.addEventListener('click', () => {
    if (!draft) return;
    navigator.clipboard.writeText(draft).then(() => {
      const icon  = container.querySelector('#copy-icon');
      const label = container.querySelector('#copy-label');
      const btn   = container.querySelector('#btn-copy');
      if (icon)  icon.className  = 'ti ti-check';
      if (label) label.textContent = '¡Copiado al portapapeles!';
      if (btn)   btn.style.background = 'var(--sev-low)';
      setTimeout(() => {
        if (icon)  icon.className  = 'ti ti-copy';
        if (label) label.textContent = 'Copiar texto completo';
        if (btn)   btn.style.background = '';
      }, 2500);
    }).catch(() => {
      // Fallback for browsers without clipboard API
      const ta = document.createElement('textarea');
      ta.value = draft;
      ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    });
  });
}
